import React from 'react';
import { useAppRoute } from '../../../../hooks/app-route-hooks';
import { TimelineDetailPageContainer } from '../../../../components/TimelineDetailPageContainer';

export const TimelineLocationEventDetails: React.FC = () => {
    const currentAppRoute = useAppRoute('TimelineLocationEventDetails');
    return (
        <TimelineDetailPageContainer
            testId="timeline-location-event-details"
            appRoute={{ type: 'TimelineLocation', locationId: currentAppRoute.locationId }}
        ></TimelineDetailPageContainer>
    );
};
